var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.size, 'wrapper', _vm.inputDirection],on:{"click":_vm.copyToClipboard}},[_c('span',{class:[_vm.inputDirection, 'text', 'input']},[_vm._v(_vm._s(_vm.inputContent))]),_vm._v(" "),_c('a',{staticClass:"copy-btn text"},[_vm._v("העתק")])])
}
var staticRenderFns = []

export { render, staticRenderFns }